import { Component, ElementRef, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { FreshAuthService } from '../fresh-auth.services';
import { UntypedFormControl, UntypedFormGroup, FormArray, UntypedFormBuilder, Validators } from '@angular/forms';
import { environment as ENV } from '../../../environments/environment';
import { environment } from '../../../environments/environment.ubi';
import { DatePipe } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AdminService } from '../../admin/admin.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AddCustomerService } from '../../admin/add-customer.service';
import * as moment from 'moment';
import { Observable } from 'rxjs';
import { AdvancedFilterService } from 'app/core/advanced-filter/advanced-filter.service';
import * as constants from '../../../app/constant';


@Component({
  selector: 'wl-view-incomplete-journey',
  providers: [AddCustomerService, AdminService],
  templateUrl: './view-incomplete-journey.component.html',
  styleUrls: ['./view-incomplete-journey.component.scss'],
})
export class ViewIncompleteJourneyComponent implements OnInit {
  noUserFound: string;
  search = new UntypedFormControl();
  searchHolder: string;
  showSelectedDate: boolean;
  currentDate: String;
  selectedDate: any;
  pageId = 1;
  page: number = 1;
  totalPage: number = 1;
  allUsers: any;
  public incompleteJrnyForm: UntypedFormGroup;
  kccNewUat: string = environment.kccNewUat;
  loading: boolean;
  filterTableDate = new Date();
  @ViewChild('date1') firstDate: ElementRef;
  formatFilterTableDate: any = new DatePipe('en-US').transform(this.filterTableDate, 'y-MM');
  limit: number = 10;
  offset: number = 0;
  failureMapping = {
    cfd_status: 'status',
    // generate_aadhar: 'aadhar_response',
    // kcc_account_fetched: 'overall_status',
    land_bre_status: 'land_bre_status',
    land_geomapping: 'response',
    // verify_aadhar: 'aadhar_response',
    cic: {
      cibil: 'npaStatus',
      experian: 'npaStatus',
    },
  };
  totalCount: any;
  iscredCount: any;
  showOrHide: boolean;
  
  display: boolean;
  roleId: number;
  subheading1: string;
  subheading2: string;
  maxDate: string;
  selectedStartDate: any;
  selectedEndDate: any;
  dateInMs: number;
  endDateInMs: number;
  showIncompleteDataTable: boolean = true;
  filter: string = "";
  isOD: boolean;
  isTN: boolean;

  constructor(
    private freshAuthService: FreshAuthService,
    private customer: FreshAuthService,
    private _fb: UntypedFormBuilder,
    private snackbar: MatSnackBar,
    private adminservice: AdminService,
    private activatedRoute: ActivatedRoute,
    private advancedFilterService: AdvancedFilterService
  ) {

    this.iscredCount = ENV.creditScoreSetting.credCount;
    if (ENV.creditScoreSetting.credMenu == 'shfl') {
      this.showOrHide = false;
    } else {
      this.showOrHide = true;
    }

    this.searchHolder = 'Search Applicant by Name';
    
    this.display = false;
  }
  onSearchClick(event) {
    this.loading = true;
  }

  onSearch(value: string) {
    this.filter = value;
    if (this.isCoLogin()) {
      return this.applyFilter(this.filter, 0, 1, 1);
    }

    this.pageId = 1;
    this.page = 1;
    this.loading = true;
    this.customer.getIncompleteUsers(value, 1, 0, 10).subscribe(
      (res) => {
        this.loading = false;
        if (res && res.success) {
          if (res.result && res.result.resultData && res.result.resultData.length === 0) {
            this.noUserFound = 'Customer data not found';
          } else {
            this.noUserFound = null;
          }
          this.allUsers = res.result.resultData || [];
          this.totalCount = res.result.count || 0;
          this.totalPage = Math.ceil(this.totalCount / 10);
        } else {
          this.noUserFound = 'Customer data not found';
          this.allUsers = [];
          this.totalCount = 0;
          this.totalPage = 0;
        }
      },
      (err) => {
        this.totalCount = 0;
        this.totalPage = 0;
        this.loading = false;
        throw err;
      }
    );
  }

  ngOnInit() {
    this.roleId = +this.freshAuthService.getRoleId();
    if (this.isCoLogin()) {
      this.showIncompleteDataTable = false;
    }
    sessionStorage.removeItem('filterDateIncompleteStart');
    sessionStorage.removeItem('filterDateIncompleteEnd');
    this.maxDate = this.freshAuthService.getCurrentMonth();
    !this.isCoLogin() && this.getData();

    this.subheading1 = this.adminservice.getBranchName();
    this.subheading2 = this.adminservice.getSolID();

    if (constants.STATES.OD.POSSIBILITIES.includes(sessionStorage.getItem('stateCode').toLowerCase())) {
      this.isOD = true;
    }else if(constants.STATES.TN.POSSIBILITIES.includes(sessionStorage.getItem('stateCode').toLowerCase())){
      this.isTN = true;
    } else {
      this.isOD = false;
      this.isTN = false;
    }
  }

  getData() {
    this.loading = true;
    const admin_id = sessionStorage.getItem('wl-admin-id');
    const branch_code = sessionStorage.getItem('branch_code');
    const ro_code = sessionStorage.getItem('ro_code');
    const zonal_code = sessionStorage.getItem('zonal_code');

    this.freshAuthService
      .loan_incomplete_jrny(
        admin_id,
        1,
        '',
        0,
        10,
        'loan_incomplete_jrny',
        branch_code,
        ro_code,
        zonal_code
      )
      .subscribe(
        (res) => {
          this.loading = false;
          console.log( 'hello',res);
          this.totalCount = res && res.count ? res.count : 0;
          this.totalPage = Math.ceil(this.totalCount / 10);
          this.allUsers = res.resultData ? res.resultData : [];
          // this.getApplicationStatus();
          console.log(this.allUsers.map((user) => user.newFailureArray));
        },
        (err) => {
          this.loading = false;
          throw err;
        }
      );
  }

  getAppStatusMessage(appStatus, trackerObj) {

    if(!appStatus) {
      if(!trackerObj.journey_tracker.verify_aadhar) {
        appStatus = "Aadhar Verification Pending";
      } else if(!trackerObj.journey_tracker.cic) {
        appStatus = "CIC Verification Pending/ CIC report not generated";
      } else if(!trackerObj.journey_tracker.verify_panvoter){
        appStatus = "PAN/Voter Verification Pending"
      }  else {
        appStatus = this.getIncompleteAppStatus(trackerObj);
      }
    }

    switch (appStatus) {
      case "loanRefNoGenerated":
        return "Land Verification Pending";
      case "satsureReportGenerated":
        return "Crop Submission Pending";
      case "cropPatternSubmitted":
        return "Loan Sanction Pending";
      case "loanAmountCalculated":
        return "Digital E-Sign Pending";
      case "docsExecutedRequest":
        return "Digital E-Sign Pending";
      case "docsExecuted":
        return "Account Opening Pending";
      case "LAND_RECORD":
        return "Cropping Pattern Selection Pending";
      case "NESL":
        return "Account Opening Pending";
      case "NESLREQUEST":
        return "Digital E-Sign Pending";
      
      default:
        return appStatus;
    }

    // if (this.isOD || this.isTN) {
    //   switch (appStatus) {
    //     case "loanRefNoGenerated":
    //       return "Land Verification Pending";
    //     case "satsureReportGenerated":
    //       return "Cropping Pattern Selection Pending";
    //     case "cropPatternSubmitted":
    //       return "Loan Sanction Pending";
    //     case "loanAmountCalculated":
    //       return "Loan Amount Sanctioned";
    //     default:
    //       return "Aadhar Verification Pending";
    //   }
    // } else {
    //   if()
    // }

  }

  getIncompleteAppStatus(trackerObj){
    let appStatus;

    let journeyTracker = trackerObj.journey_tracker;

    if(journeyTracker.verify_aadhar.name_match === 'pending') {
      appStatus = "Aadhar Verification Pending";
    } else if(journeyTracker.cicreport.cibil.npaStatus === 'pending') {
      appStatus = "CIC Verification Pending/ CIC report not generated";
    } else if(journeyTracker.verify_panvoter.name_match === 'pending'){
      appStatus = "PAN/Voter Verification Pending"
    }  else {
      appStatus = "Incomplete Journey"
    }

    return appStatus;
  }
  

  // getApplicationStatus() {
  //   try {
  //     this.allUsers = this.allUsers.map((user) => {
  //       let newFailureArray = [];
  //       let failureArray = [];
  //       let journeyTracker = user.trackerObj.journey_tracker;
  //       console.log('journy', journeyTracker);
  //       //let keysToCheck = ['kcc_account_fetched','generate_aadhar','verify_aadhar','cfd_status','experian','cibil','land_bre_status','land_geomapping']
  //       let keysToCheck = [
  //         // 'kcc_account_fetched',
  //         // 'generate_aadhar',
  //         // 'verify_aadhar',
  //         'cfd_status',
  //         'cicreport',
  //         'land_bre_status',
  //         'land_geomapping',
  //       ];
  //       for (let key of keysToCheck) {
  //         if (journeyTracker && journeyTracker.hasOwnProperty(key)) {
  //           let newFailureObj = this.getFailureResults(key, journeyTracker[key]);
  //           newFailureArray.push(...newFailureObj);
  //           let failureObj = this.getFailureStatus(key, journeyTracker[key]);
  //           failureArray.push(failureObj);
  //         }
  //       }
  //       console.log('newFailureArray after for', newFailureArray);
  //       let mapObj = {
  //         ...user,
  //         ...(failureArray.length > 0 && {
  //           failureArray: failureArray.filter((obj) => !obj.status),
  //         }),
  //         newFailureArray: newFailureArray,
  //       };
  //       return mapObj;
  //     });
  //   } catch (err) {
  //     console.log('coming error', err);
  //   }
  // }
  // getFailureStatus(key, object) {
  //   const res: string | object[] = object[this.failureMapping[key]];
  //   if (typeof res == 'string') {
  //     if (res.toLowerCase() == 'failure') {
  //       return { value: key, status: false, date: new Date(object['date']) };
  //     } else return { value: key, status: true, date: new Date(object['date']) };
  //   } else if (typeof res == 'object') {
  //     for (const sKey in res) {
  //       if (sKey == 'cibil' || sKey == 'experian') {
  //         if (object[0][sKey].toLowerCase() == 'failure') {
  //           return { value: sKey, status: false, date: new Date(object['date']) };
  //         } else {
  //           return { value: sKey, status: true, date: new Date(object['date']) };
  //         }
  //       } else return { value: sKey, status: true, date: new Date(object['date']) };
  //     }
  //   } else return { value: key, status: true, date: new Date(object['date']) };
  // }
  // getFailureResults(key, object): any {
  //   let returnedArr = [];
  //   switch (key) {
  //     // case 'cic' :
  //     //   if(typeof object == 'object'){
  //     //     let sReturnedArr = []
  //     //     for(key in object[0])
  //     //       sReturnedArr.push(...this.getFailureResults(key, object[0][key]))
  //     //     return sReturnedArr;
  //     //   }
  //     // case 'experian':
  //     case 'cic':
  //       if (object.npaStatus == 'pending') {
  //         return [
  //           {
  //             message: 'CIC Verification pending',
  //             date: moment(new Date(object.date)).format('DD/MM/YYYY'),
  //           },
  //         ];
  //       }
  //       break;

  //     case 'cicreport':
  //       if (
  //         object.cibil &&
  //         object.cibil.npaStatus == 'pending' &&
  //         object.experian &&
  //         object.experian.npaStatus == 'pending'
  //       ) {
  //         return [
  //           {
  //             message: 'CIC Verification pending',
  //             date: moment(new Date(object.date)).format('DD/MM/YYYY'),
  //           },
  //         ];
  //       }
  //       break;
  //     // case 'generate_aadhar':
  //     //   if (object.aadhar_response == 'pending')
  //     //     returnedArr.push({
  //     //       message: 'Aadhaar verification pending',
  //     //       date: moment(new Date(object.date)).format('DD/MM/YYYY'),
  //     //     });

  //     //   break;

  //     // case 'verify_aadhar':
  //     //   if (object.aadhar_response == 'pending')
  //     //     returnedArr.push({
  //     //       message: 'Aadhaar verification pending',
  //     //       date: moment(new Date(object.date)).format('DD/MM/YYYY'),
  //     //     });
  //     //   if (object.aadhar_details_number_mismatch == 'pending')
  //     //     returnedArr.push({
  //     //       message: 'Aadhaar verification pending',
  //     //       date: moment(new Date(object.date)).format('DD/MM/YYYY'),
  //     //     });
  //     //   if (object.agestatus == 'pending')
  //     //     returnedArr.push({
  //     //       message: 'Aadhaar verification pending',
  //     //       date: moment(new Date(object.date)).format('DD/MM/YYYY'),
  //     //     });
  //     //   if (object.agestatus == 'pending')
  //     //     returnedArr.push({
  //     //       message: 'Aadhaar verification pending',
  //     //       date: moment(new Date(object.date)).format('DD/MM/YYYY'),
  //     //     });

  //     //   break;

  //     // case 'kcc_account_fetched':
  //     //   if (object.overall_status == 'pending')
  //     //     returnedArr.push({
  //     //       message: 'Customer verification pending',
  //     //       date: moment(new Date(object.date)).format('DD/MM/YYYY'),
  //     //     });
  //     //   break;

  //     case 'land_bre_status':
  //       if (object.land_bre_status == 'pending' || object.land_bre_status == 'failure')
  //         returnedArr.push({
  //           message: 'Land Verification pending',
  //           date: moment(new Date(object.date)).format('DD/MM/YYYY'),
  //         });
  //       if (object.profile_match == 'pending' || object.profile_match == 'failure')
  //         returnedArr.push({
  //           message: 'Land Verification pending',
  //           date: moment(new Date(object.date)).format('DD/MM/YYYY'),
  //         });
  //       if (object.isIrrigated == 'pending')
  //         returnedArr.push({
  //           message: 'Land Verification pending',
  //           date: moment(new Date(object.date)).format('DD/MM/YYYY'),
  //         });
  //       if (object.isMortgage == 'pending')
  //         returnedArr.push({
  //           message: 'Land Verification pending',
  //           date: moment(new Date(object.date)).format('DD/MM/YYYY'),
  //         });
  //       if (object.isCourtCase == 'pending')
  //         returnedArr.push({
  //           message: 'Land Verification pending',
  //           date: moment(new Date(object.date)).format('DD/MM/YYYY'),
  //         });
  //       if (object.ownershare == 'pending')
  //         returnedArr.push({
  //           message: 'Land Verification pending',
  //           date: moment(new Date(object.date)).format('DD/MM/YYYY'),
  //         });
  //       if (object.final_status == 'pending' || object.final_status == 'failure')
  //         returnedArr.push({
  //           message: 'Land Verification pending',
  //           date: moment(new Date(object.date)).format('DD/MM/YYYY'),
  //         });
  //       break;

  //     case 'land_geomapping':
  //       if (object.request == 'pending')
  //         returnedArr.push({
  //           message: 'Satellite Report generation pending',
  //           date: moment(new Date(object.date)).format('DD/MM/YYYY'),
  //         });
  //       if (object.response == 'pending')
  //         returnedArr.push({
  //           message: 'Satellite Report generation pending',
  //           date: moment(new Date(object.date)).format('DD/MM/YYYY'),
  //         });
  //       break;

  //     case 'cfd_status':
  //       if (object.status == 'pending')
  //         returnedArr.push({
  //           message: 'CFR Check pending',
  //           date: moment(new Date(object.date)).format('DD/MM/YYYY'),
  //         });
  //       break;

  //     default:
  //       return [
  //         {
  //           message: '',
  //           date: moment(new Date()).format('DD/MM/YYYY'),
  //         },
  //       ];
  //   }
  //   return returnedArr;
  // }

  getAllUsersPage(input, roleId, offset, limit, pageId) {
    if (this.isCoLogin()) {
      return this.applyFilter(input, offset, pageId, pageId);
    }

    this.pageId = pageId;
    this.loading = true;

    console.log('before page ' + this.page + 'offset ' + this.offset + 'limit ' + this.limit);
    this.page = pageId;
    this.offset = offset;
    this.limit = limit;

    console.log('after page ' + this.page + 'offset ' + this.offset + 'limit ' + this.limit);

    this.customer.getUsers(input, roleId, offset, limit, 'loan_incomplete_jrny').subscribe(
      (res) => {
        this.loading = false;
        console.log('result ' + JSON.stringify(res));
        this.allUsers = res && res.result && res.result.resultData ? res.result.resultData : [];

        this.totalCount = res && res.result && res.result.count ? res.result.count : 0;
        this.totalPage = Math.ceil(this.totalCount / 10);
        console.log('this.totalPage ' + this.totalPage);

      },
      (err) => {
        this.loading = false;
        this.allUsers = Observable[''];
        throw err;
      }
    );
  }

  onDateRangeSelected(dateRange: any) {
    this.pageId = 1;
    this.page = 1;
    this.offset = 0;
    this.selectedStartDate = dateRange.startDate;
    this.selectedEndDate = dateRange.endDate;
    console.log(dateRange.startDate, dateRange.endDate);
    let date = new Date(this.selectedStartDate);
    this.dateInMs = date.getTime();
    let strStart = this.dateInMs.toString();
    sessionStorage.setItem('filterDateIncompleteStart', strStart);
    let storeEnddate = new Date(this.selectedEndDate);
    this.endDateInMs = storeEnddate.getTime();
    let strEnd = this.endDateInMs.toString();
    sessionStorage.setItem('filterDateIncompleteEnd', strEnd);
    console.log('check date', this.endDateInMs);
    if (this.dateInMs <= this.endDateInMs) {
      let dateType = 'dateRange';
      this.showSelectedDate = true;
      let startDateConvert = dateRange.startDate.split('-').reverse().join('-');
      let endDateConvert = dateRange.endDate.split('-').reverse().join('-');
      this.selectedDate = startDateConvert + ' - ' + endDateConvert;
      this.customer
        .getIncompleteUsersFilterDate(
          '',
          this.roleId,
          0,
          10,
          this.dateInMs,
          this.endDateInMs,
          dateType
        )
        .subscribe((res) => {
          console.log(res);
          if (res && res.result && res.result.resultData) {
            if (res && res.result && res.result.resultData) {
              this.allUsers = res.result.resultData ? res.result.resultData : '';
              this.totalCount = res && res.result && res.result.count ? res.result.count : 0;
              this.totalPage = Math.ceil(this.totalCount / 10);
            }
          } else {
            // this.allUsers = this.getEmptyArray()
            this.closeButtonClick();
            this.snackbar.open('No Applicants found. The Filter is not Applied', 'OK', {
              duration: 4000,
            });
          }
        });
    } else {
      this.snackbar.open('Please enter the valid date', 'OK', { duration: 4000 });
    }
  }

  closeButtonClick() {
    this.selectedDate = '';
    this.showSelectedDate = false;
    sessionStorage.removeItem('filterDateIncompleteStart');
    sessionStorage.removeItem('filterDateIncompleteEnd');
    sessionStorage.removeItem('filterDateSanction');
    this.adminservice.reloadComponent(this.activatedRoute.snapshot['_routerState'].url);
  }
  ngOnDestroy() {
    console.log('foo destroy');
    sessionStorage.removeItem('filterDateIncompleteStart');
    sessionStorage.removeItem('filterDateIncompleteEnd');
  }

  isCoLogin() {
    if (this.roleId === 1) {
      return true;
    }
    return false;
  }

  applyFilter(filter: string = '', offset: number = 0, pageId: number = 1, page: number = 1) {
    this.pageId = pageId;
    this.page = page;
    this.offset = offset;
    this.loading = true;
    this.showIncompleteDataTable = true;
    const formData = this.advancedFilterService.getFilterData();
    formData.filter = filter;
    formData.offset = offset;
    try {
      this.freshAuthService.getIncompleteJourneys(formData).subscribe(
        (response) => {
          this.noUserFound = '';
          this.allUsers = response && response.resultData ? response.resultData : [];
          if (!this.allUsers.length) {
            this.noUserFound = 'Customer data not found';
          } else {
            // this.getApplicationStatus();
          }
          this.totalCount = response && response.count ? response.count : 0;
          this.totalPage = Math.ceil(this.totalCount / 10);
          this.loading = false;
        },
        () => {
          this.noUserFound = 'Customer data not found';
          this.loading = false;
          this.totalCount = 0;
          this.totalPage = 0;
        }
      );
    } catch (error) {
      this.snackbar.open(error.message, 'OK', {
        duration: 4000,
      });
      this.loading = false;
      this.totalCount = 0;
      this.totalPage = 0;
    }
  }
}
